export class CommunicationTokenModel {
	key: string;
	name: string;
	type: string;
	description?: string;
}
